const React = require('react');
const PropTypes = require('prop-types');
const { formatText } = require('core/i18n').i18n;
const { formatAmount } = require('utilities/currencyHelper');
const holdingIndustryType = require('utilities/holdingIndustryType');
const DataTable = require('components/charts/DataTable/DataTable');
const DataTableColumn = require('components/charts/DataTableColumn/DataTableColumn');

const PortfolioHoldingsDesktop = ({ data }) => (
    <DataTable data={data}>
        <DataTableColumn dataKey="securityName" />
        <DataTableColumn
            dataKey="industryId"
            format={v => holdingIndustryType(v)}
            header={formatText('fundsCard-field')}
        />
        <DataTableColumn
            dataKey="countryId"
            header={formatText('fundsCard-country')}
        />
        <DataTableColumn
            dataKey="weighting"
            header={formatText('fundsCard-percentage')}
            format={v => `${formatAmount(v)}%`}
        />
    </DataTable>
);

PortfolioHoldingsDesktop.propTypes = {
    data: PropTypes.array.isRequired,
};

module.exports = PortfolioHoldingsDesktop;
